"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoData = exports.NoDataContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const Paragraph_1 = require("../Paragraph");
exports.NoDataContainer = styled_components_1.default.div `
  padding: ${style_1.default.Layout.Spacing.Base};
  text-align: center;
`;
const NoData = ({ children, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.NoDataContainer, { children: (0, jsx_runtime_1.jsx)(Paragraph_1.Paragraph, { children: children }) }));
};
exports.NoData = NoData;
